import axios from 'axios'

export default {
    namespaced: true,
    state: {
        settings : []
    },
    mutations: {
        FETCH_SETTINGS(state, settings) {
            state.settings = settings
        },
        EDIT_SETTINGS(state, setting) {
            const index = state.settings.findIndex(
                item => item.id === setting.id
            )
            Object.assign(state.settings[index], setting)
        },
    },
    actions: {
        fetch({commit, dispatch, state}, payload = {}) {
            return new Promise((resolve, reject) => {
                if (state.settings.length) {
                    resolve(state.settings)
                } else {
                    axios.post('/api/mixins/settings/list', payload).then(({data}) => {
                        commit('FETCH_SETTINGS', data.data)
                        resolve(data.data)
                    }).catch((error) => {
                        dispatch('checkUnauthenticated', error, { root: true })
                        reject(error)
                    })
                }
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve, reject) => {
                axios.put(
                    '/api/mixins/settings/edit/' + editedItem.id,
                    editedItem
                ).then(({data}) => {
                    commit('EDIT_SETTINGS', data.data)
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
    }
}
